import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Speciality } from '../models/speciality.model';

@Injectable({
  providedIn: 'root',
})
export class SpecialityService {
  private specialities: Speciality[] = [];
  public specialitiesChanged = new Subject<Speciality[]>();

  constructor(private http: HttpClient) {}

  getSpecialities(): Observable<Speciality[]> {
    return this.http.get<Speciality[]>('/specialities').pipe(
      tap((res) => {
        this.specialities = res;
        this.specialitiesChanged.next(this.specialities.slice());
      })
    );
  }

  createSpeciality(payload: { name: string }) {
    return this.http.post('/specialities', payload).pipe(
      tap(() => {
        this.getSpecialities().subscribe();
      })
    );
  }

  updateSpeciality(id: string, payload: { name: string }) {
    return this.http.put(`/specialities/${id}`, payload).pipe(
      tap(() => {
        this.getSpecialities().subscribe();
      })
    );
  }

  deleteSpeciality(id: string) {
    return this.http.delete(`/specialities/${id}`).pipe(
      tap(() => {
        this.getSpecialities().subscribe();
      })
    );
  }
}
